import { createContext, useContext } from "react";

// Create a Context to store action handlers
const ActionHandlerContext = createContext({
  rowActionHandler: {},
  reportActionHandler: {},
  interfaceActionHandler: {},
});

// Provider component to wrap around your component tree
export const ActionHandlerProvider = ({
  children,
  rowActionHandler = {},
  reportActionHandler = {},
  interfaceActionHandler = {},
}) => {
  return (
    <ActionHandlerContext.Provider
      value={{ rowActionHandler, reportActionHandler, interfaceActionHandler }}
    >
      {children}
    </ActionHandlerContext.Provider>
  );
};

// Custom hook to use the ActionHandlerContext
export const useActionHandler = () => {
  const context = useContext(ActionHandlerContext);
  if (!context) {
    throw new Error(
      "useActionHandler must be used within an ActionHandlerProvider"
    );
  }
  return context;
};
